// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/LisHero';
import Intro from '../components/LisIntro';
import Stats from '../components/LisCEO';
import Footer from '../components/Footer';

function LighthouseInternational() {
  return (
    <>
      <Intro />
      <Hero />
      <Stats />
      <Footer />
    </>
  );
}

export default LighthouseInternational;
